<template>
  <section class="savePage">
    <Header />
    <div class="container">
      <div class="row">
        <div class="savePage__title">
          <span v-if="!isShowLink">Сохранить объект в системе</span>
          <span v-else>Проект успешно сохранен в системе</span>
        </div>
      </div>
      <div class="row" v-if="!isShowLink">
        <div class="savePage__form-wrapper">
          <div class="item">
            <form
              @submit.prevent="checkForm" novalidate="true">
              <div class="input__wrapper"
                   :class="{ 'form-group--error': $v.objectName.$error,
                   'complete': objectName !== '',
                   'active': currentInput === 'objectName'}">
                <div class="input__wrapper-label form__label">Название объекта</div>
                <div class="input__wrapper-input">
                  <div class="error" v-if="!$v.objectName.required">Поле обязательно</div>
                  <div class="error" v-if="!$v.objectName.minLength">
                    Поле должно быть длинне {{$v.objectName.$params.minLength.min}}-ти символов
                  </div>
                  <input class="form__input"
                         @focus="currentInput = 'objectName'"
                         v-model.trim="$v.objectName.$model"
                         @input="delayTouch($v.objectName)"/>
                </div>
              </div>
              <div class="input__wrapper"
                   :class="{ 'form-group--error': $v.adress.$error,
                   'complete': adress !== '',
                   'active': currentInput === 'adress'}">
                <div class="input__wrapper-label form__label">Адрес объекта</div>
                <div class="input__wrapper-input">
                  <div class="error" v-if="!$v.adress.required">Поле обязательно</div>
                  <div class="error" v-if="!$v.adress.minLength">
                    Поле должно быть длинне {{$v.adress.$params.minLength.min}}-ти символов</div>
                  <input class="form__input"
                         @focus="currentInput = 'adress'"
                         v-model.trim="$v.adress.$model"
                         @input="delayTouch($v.adress)"/>
                </div>
              </div>
              <div class="input__wrapper" :class="{ 'form-group--error': $v.userName.$error,
                   'complete': userName !== '',
                   'active': currentInput === 'userName'}">
                <div class="input__wrapper-label form__label">ФИО</div>
                <div class="input__wrapper-input">
                  <div class="error" v-if="!$v.userName.required">Поле обязательно</div>
                  <div class="error" v-if="!$v.userName.minLength">
                    Поле должно быть длинне {{$v.userName.$params.minLength.min}}-х символов</div>
                  <input class="form__input"
                         @focus="currentInput = 'userName'"
                         v-model.trim="$v.userName.$model"
                         @input="delayTouch($v.userName)"/>
                </div>
              </div>
              <div class="input__wrapper" :class="{ 'form-group--error': $v.userEmail.$error,
                   'complete': userEmail !== '',
                   'active': currentInput === 'userEmail'}">
                <div class="input__wrapper-label form__label">E-mail</div>
                <div class="input__wrapper-input">
                  <div class="error" v-if="!$v.userEmail.required">Поле обязательно</div>
                  <div class="error" v-if="!$v.userEmail.email">
                    E-mail не валиден</div>
                  <input class="form__input"
                         @focus="currentInput = 'userEmail'"
                         v-model.trim="$v.userEmail.$model"
                         @input="delayTouch($v.userEmail)"/>
                </div>
              </div>
              <div class="input__wrapper" :class="{ 'form-group--error': $v.userPhone.$error,
                   'complete': userPhone !== '',
                   'active': currentInput === 'userPhone'}">
                <div class="input__wrapper-label form__label">Телефон</div>
                <div class="input__wrapper-input">
                  <div class="error" v-if="!$v.userPhone.required">Поле обязательно</div>
                  <div class="error" v-if="!$v.userPhone.minLength">
                    Поле должно быть длинне
                    {{$v.userPhone.$params.minLength.min}}-ми символов</div>
                  <input class="form__input" type="number"
                         @focus="currentInput = 'userPhone'"
                         v-model.number="$v.userPhone.$model"
                         @input="delayTouch($v.userPhone)"/>
                </div>
              </div>
              <div class="input__wrapper"
                   :class="{'complete': company !== '',
                   'active': currentInput === 'company'}">
                <div class="input__wrapper-label">
                  Компания
                </div>
                <div class="input__wrapper-input">
                  <input type="text"
                         @focus="currentInput = 'company'"
                         v-model="company"
                         placeholder="">
                </div>
              </div>
              <div class="form-checkbox">
                <input type="checkbox"
                       class="checkbox"
                       id="form-privacy"
                       v-model="$v.privacy.$model">
                <label for="form-privacy" class="tick"></label>
                <label for="form-privacy"
                       :class="{'checkbox-label': true,
                              'checkbox-label--error': $v.privacy.$error}">
                  Я согласен на обработку своих персональных данных. <br>
                  Нажимая кнопку "Сохранить расчет", я подтверждаю, что ознакомился с
                  <a href="https://nav.tn.ru/privacy/" target="_blank">Политикой обработки
                    персональных данных ЗАО "ТехноНИКОЛЬ"</a> и даю согласие на обработку всех моих
                  персональных данных указанных в форме.
                </label>
              </div>
              <div class="info__wrapper-box info__wrapper-box--form">
                <img src="@/assets/img/info.svg" alt="i" class="info__wrapper-img">
                <div class="info__wrapper-text">
                  {{ infoContent }}
                </div>
              </div>
              <div class="captcha">
                <div class="captcha__layout" ref="captcha"></div>
                <div class="captcha__error" v-if="isCaptchaErrorShow">
                  Подтвердите что вы не робот
                </div>
              </div>
              <button type="submit" class="btn">
                <span>Сохранить расчет</span>
                <img src="@/assets/img/cloud.svg" alt="cloud">
              </button>
            </form>
          </div>
          <div class="item info__wrapper">
            <div class="info__wrapper-box info__wrapper-box--outer">
              <img src="@/assets/img/info.svg" alt="i" class="info__wrapper-img">
              <div class="info__wrapper-text">
                {{ infoContent }}
              </div>
            </div>
            <router-link to="/result/" class="btn__back">
              <svg width="26" height="29" viewBox="0 0 26 29"
                   fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24 13.6667V3.66667C24 2.75 23.2929 2 22.4286 2H3.57143C2.70714 2 2 2.75 2
                      3.66667V13.6667M24 13.6667H2M24 13.6667L23.9999 25.3333C23.9999 26.2499
                      23.2928 26.9999 22.4285 26.9999L16.143 27M24 13.6667L16.143 13.6666M2
                      13.6667L9.07143 13.6666M2 13.6667V20.3333M9.07143 13.6666V20.3333M9.07143
                      13.6666H16.143M9.07143 20.3333H2M9.07143 20.3333V27M9.07143 20.3333H16.143M2
                      20.3333V25.3333C2 26.25 2.70714 27 3.57143 27H9.07143M9.07143 27H16.143M16.143
                      13.6666V20.3333M16.143 13.6666V27M16.143 20.3333V27" stroke="#E30713"
                      stroke-width="3" stroke-miterlimit="22.9256" stroke-linecap="round"
                      stroke-linejoin="round"></path>
              </svg>
              <span>Вернуться к полному расчету</span>
            </router-link>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div class="row copyLink" v-if="isShowLink">
          <div class="copyLink__wrapper">
            <div class="copyLink__wrapper-img">
              <img src="@/assets/img/link.svg" alt="link">
            </div>
            <input type="text" ref="link"
                   :value="`${this.domenName}/result/?object=${this.hashFromDB}`"
                   class="copyLink__wrapper-input" readonly="readonly">
            <button @click="copy()" class="copyLink__wrapper-btn">
              копировать <span>ссылку</span>
            </button>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="row copyLink" v-if="isShowLink">
          <div class="info__wrapper-box info__wrapper-box--save">
            <img src="@/assets/img/info.svg" alt="i" class="info__wrapper-img">
            <div class="info__wrapper-text">
              На вашу почту была отправлена ссылка на текущую версию проекта.
              Обратите внимание, если вы в дальнейшем внесете изменения в проект, то при сохранении
              проекта вам будет предоставлена новая ссылка.
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="row copyLink" v-if="isShowLink">
          <router-link to="/result/" class="btn__back btn__back-save">
            <svg width="26" height="29" viewBox="0 0 26 29"
                 fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M24 13.6667V3.66667C24 2.75 23.2929 2 22.4286 2H3.57143C2.70714 2 2 2.75 2
                        3.66667V13.6667M24 13.6667H2M24 13.6667L23.9999 25.3333C23.9999 26.2499
                        23.2928 26.9999 22.4285 26.9999L16.143 27M24 13.6667L16.143 13.6666M2
                        13.6667L9.07143 13.6666M2 13.6667V20.3333M9.07143 13.6666V20.3333M9.07143
                        13.6666H16.143M9.07143 20.3333H2M9.07143 20.3333V27M9.07143 20.3333H16.143M2
                        20.3333V25.3333C2 26.25 2.70714 27 3.57143 27H9.07143M9.07143
                        27H16.143M16.143
                        13.6666V20.3333M16.143 13.6666V27M16.143 20.3333V27" stroke="#E30713"
                    stroke-width="3" stroke-miterlimit="22.9256" stroke-linecap="round"
                    stroke-linejoin="round"></path>
            </svg>
            <span>Вернуться к полному расчету</span>
          </router-link>
          <button @click="newCalculate()" class="btn__back btn__back-save">
            <svg width="26" height="15" viewBox="0 0 26 15"
                 fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.91124 7.53846L26.1428 7.53846M8.45861 1.07692L2.14282
                      7.53846L8.45861 14" stroke="#E30713"
                    stroke-width="2" stroke-miterlimit="22.9256"></path>
              <rect x="3.98901" y="8.46155" width="0.923077"
                    height="1.84615" transform="rotate(180 3.98901 8.46155)"
                    fill="#E30713"></rect>
            </svg>
            <span>Начать новый расчет</span>
          </button>
        </div>
      </transition>
    </div>
    <Footer />
  </section>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations } from 'vuex';
import {
  required, minLength, email, sameAs,
} from 'vuelidate/lib/validators';
import Header from '../components/Header.vue';
import Footer from '../components/Footer.vue';
import { dataLayerPushEvent } from '@/utils/GTM';

axios.defaults.withCredentials = false;
axios.defaults.headers.common['Content-Type'] = 'application/json';

const touchMap = new WeakMap();

export default {
  data() {
    return {
      isCaptchaPassed: false,
      isCaptchaErrorShow: false,
      currentInput: '',
      image: 'qwe',
      domenName: '',
      hashFromDB: '',
      isHover: false,
      adress: '',
      objectName: '',
      company: '',
      userName: '',
      userPhone: '',
      userEmail: '',
      privacy: false,
      isShowLink: false,
      infoContent: 'После сохранения объекта в системе, вы получите внутреннюю ссылку на проект. По ссылке в любой удобный момент вы сможете открыть проект и при необходимости внести в него корректировку. Ссылка на текущую версию проекта будет вам отправлена на указанную электронную почту.',
    };
  },
  validations: {
    userName: {
      required,
      minLength: minLength(4),
    },
    userPhone: {
      required,
      minLength: minLength(8),
    },
    userEmail: {
      required,
      email,
    },
    adress: {
      required,
      minLength: minLength(6),
    },
    objectName: {
      required,
      minLength: minLength(6),
    },
    privacy: {
      sameAs: sameAs(() => true),
    },
  },
  methods: {
    delayTouch($v) {
      $v.$reset();
      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v));
      }
      touchMap.set($v, setTimeout($v.$touch, 1000));
    },
    ...mapMutations({
      UPDATE_USER_INFO_PARAM: 'UPDATE_USER_INFO_PARAM',
      RESET_SECTORS: 'RESET_SECTORS',
      ADD_NEW_SECTOR: 'ADD_NEW_SECTOR',
    }),
    async checkForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.currentInput = '';
        // validation no pass
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      } else if (this.isCaptchaPassed) {
        dataLayerPushEvent('calc-roofload-save-form');
        this.currentInput = '';
        // validation pass
        const postData = new URLSearchParams();
        const baseUrl = (process.env.NODE_ENV === 'development') ? process.env.VUE_APP_API_URL : `${window.location.origin}/`;
        postData.append('data', JSON.stringify(this.sectors));
        postData.append('location', JSON.stringify(this.location));
        postData.append('name', this.userName);
        postData.append('objectName', this.objectName);
        postData.append('company', this.company);
        postData.append('phone', this.userPhone);
        postData.append('email', this.userEmail);
        postData.append('address', this.adress);
        // eslint-disable-next-line no-restricted-globals
        postData.append('url', `${location.origin}/result/?object=`);
        postData.append('result', JSON.stringify(this.result));
        this.UPDATE_USER_INFO_PARAM({
          param: 'userName',
          val: this.userName,
        });
        this.UPDATE_USER_INFO_PARAM({
          param: 'userPhone',
          val: this.userPhone,
        });
        this.UPDATE_USER_INFO_PARAM({
          param: 'userMail',
          val: this.userEmail,
        });
        this.UPDATE_USER_INFO_PARAM({
          param: 'objectName',
          val: this.objectName,
        });
        this.UPDATE_USER_INFO_PARAM({
          param: 'objectAdress',
          val: this.adress,
        });
        this.UPDATE_USER_INFO_PARAM({
          param: 'userCompany',
          val: this.company,
        });
        axios.post(`${baseUrl}service_api/results_save`, postData)
          .then((response) => {
            this.hashFromDB = response.data;
            this.UPDATE_USER_INFO_PARAM({
              param: 'link',
              val: `${this.domenName}/result/?object=${this.hashFromDB}`,
            });
            this.isShowLink = true;
          });
      } else {
        this.isCaptchaErrorShow = true;
      }
    },
    copy() {
      /* eslint-disable import/no-unresolved */
      /* eslint-disable global-require */
      const copyCode = this.$refs.link;
      copyCode.select();
      document.execCommand('copy');
      this.$notify({
        group: 'foo',
        type: 'success',
        title: 'ссылка скопирована в буфер',
        text: require('@/assets/img/notify.svg'),
      });
      /* eslint-enable import/no-unresolved */
      /* eslint-enable global-require */
    },
    newCalculate() {
      this.RESET_SECTORS();
      this.ADD_NEW_SECTOR();
      this.$router.push('/');
      // location.reload();
    },
  },
  mounted() {
    // eslint-disable-next-line no-restricted-globals
    this.domenName = location.origin;
    // console.log(this.domenName);
    if (this.location.zone === '') {
      this.$router.push('/');
    } else {
      const { grecaptcha } = window;
      grecaptcha.ready(() => {
        grecaptcha.render(this.$refs.captcha, {
          sitekey: process.env.VUE_APP_RECAPTCHA_KEY,
          'expired-callback': () => {
            this.isCaptchaPassed = false;
          },
          'error-callback': () => {
            this.isCaptchaPassed = false;
          },
          callback: () => {
            this.isCaptchaPassed = true;
            this.isCaptchaErrorShow = false;
          },
        });
      });
    }
  },
  computed: {
    ...mapState({
      result: state => state.result,
      sectors: state => state.sectors,
      location: state => state.location,
    }),
  },
  components: {
    Header,
    Footer,
  },
};

</script>

<style lang="sass" scoped>
  .savePage
    color: $black
    &__title
      font-style: normal
      font-weight: 500
      text-align: left
      +media((padding: (320: rem(32) rem(24), 992: rem(50) 0)))
      +media((font-size: (320: rem(22), 960: rem(28))))
      +media((line-height: (320: rem(29), 960: rem(34))))
    &__form
      &-wrapper
        width: 100%
        display: grid
        +media((grid-template-columns: (320: 1fr, 960: 7fr 5fr)))
        +media((padding: (320: 0 rem(24), 960: 0)))
        +media((padding-bottom: (320: rem(32), 768: rem(68))))
        .item
          +media((padding: (320: 0)))

          .captcha
            margin: rem(20) 0
            +media((max-width: (0: rem(272), 360: unset)))
            +media((max-height: (0: rem(70), 360: unset)))
            &__layout
              transform-origin: 0 0
              +media((transform: (0: scale(0.89), 360: none)))
            &__error
              font-size: rem(12)
              color: $red
              text-align: left
          .form-checkbox
            display: flex
            align-items: flex-start
            flex-direction: row
            +media((margin: (320: rem(34) 0 0)))
            .tick
              background: #ffffff
              height: rem(18)
              width: rem(18)
              border-radius: rem(4)
              flex: 0 0 rem(18)
              border: rem(1) solid #D6D6D6
              cursor: pointer
              display: flex
              justify-content: center
              align-items: center
              transition: .5s
              @media (any-hover: hover)
                &:hover
                  &:before
                    opacity: 1
              &:before
                content: url("../assets/img/form-tick--red.svg")
                position: relative
                display: block
                line-height: 0
                pointer-events: none
                opacity: 0
                transition: .5s
            .checkbox
              position: absolute
              pointer-events: none
              display: none
              height: 0
              width: 0
              &:checked
                + .tick
                  background: $red
                  border-color: $red
                  &:before
                    opacity: 1
                    content: url("../assets/img/form-tick.svg")
              &-label
                text-align: left
                font-size: rem(12)
                margin-left: rem(10)
                a
                  color: $red
                &--error
                  color: red
          .input
            &__wrapper
              width: 100%
              display: flex
              align-items: center
              position: relative
              +media((margin-bottom: (320: rem(8), 768: 0)))
              +media((height: (320: auto, 768: rem(68))))
              +media((flex-direction: (320: column, 768: row)))
              &.complete, &.active
                .input
                  &__wrapper
                    &-label
                      +media((font-size: (320: rem(10), 768: rem(14))))
                      +media((top: (320: rem(8), 768: unset)))
                      transform: translateY(0)
              &-label, &-input
                height: 100%
                display: flex
                flex-direction: row
                align-items: center
                background: #F6F6F6
                border: rem(1) solid #ECECEC
                box-sizing: border-box
                border-radius: rem(4) 0 0 rem(4)
              .error
                position: absolute
                top: 0
                width: 100%
                font-size: rem(12)
                font-weight: $main-font
                font-weight: 500
                color: red
                text-align: right
                padding-top: rem(5)
                padding-right: rem(10)
                opacity: 0
                +media((display: (320: none, 768: block)))
              &.form-group--error
                .error
                  opacity: 1
                .form__label
                  +media((color: (320: red, 768: $black)))
                .form__input
                  +media((border-color: (320: #EA5B62, 768: transparent)))
                  +media((border-width: (320: rem(2), 768: rem(1))))
              &-label
                text-align: left
                font-style: normal
                font-weight: bold
                line-height: rem(18)
                padding-bottom: 0
                transition: .5s
                +media((border: (320: none, 768: rem(1) solid #ECECEC)))
                +media((height: (320: auto, 768: 100%)))
                +media((color: (320: #999999, 992: $black)))
                +media((width: (320: 100%, 768: rem(200))))
                +media((max-width: (320: unset, 768: rem(200))))
                +media((background: (320: transparent, 768: #F6F6F6)))
                +media((padding-left: (320: rem(20), 768: rem(30))))
                +media((font-size: (320: rem(12), 768: rem(14))))
                pointer-events: none
                +media((position: (320: absolute, 768: relative)))
                +media((top: (320: 50%, 768: unset)))
                +media((transform: (320: translateY(-50%), 768: translateY(0))))
                z-index: 2
              &-input
                position: relative
                +media((width: (320: 100%, 768: calc(100% - 200px))))
                // +media((margin-bottom: (320: rem(23), 768: 0)))
                //+media((margin-bottom: (320: rem(23), 768: 0)))
                input
                  height: 100%
                  width: 100%
                  border: rem(1) solid
                  outline: none
                  box-shadow: none
                  text-align: left
                  font-style: normal
                  font-weight: bold
                  line-height: rem(18)
                  color: $black
                  caret-color: $red
                  transition: .5s
                  +media((padding-top: (320: rem(12), 768: 0)))
                  +media((border-color: (320: #D6D6D6, 768: transparent)))
                  +media((font-size: (320: rem(12), 768: rem(14))))
                  +media((padding-left: (320: rem(16), 768: rem(25))))
                  +media((border-radius: (320: rem(4), 768: 0)))
                  +media((height: (320: rem(54), 768: 100%)))
                  &:focus, &:hover
                    box-shadow: 0 rem(4) rem(12) rgba(0, 0, 0, 0.12)
        .btn
          background: $green
          box-shadow: none
          outline: none
          border: none
          +media((width: (320: 100%, 768: 50%, 960: 100%)))
          color: #fff
          font-family: $main-font
          font-style: normal
          font-weight: bold
          line-height: rem(22)
          border-radius: rem(4)
          transition: .5s
          padding-left: rem(25)
          padding-right: rem(30)
          height: rem(68)
          margin-top: rem(34)
          cursor: pointer
          display: flex
          flex-direction: row
          align-items: center
          justify-content: space-between
          +media((height: (320: rem(64), 768: rem(68))))
          +media((font-size: (320: rem(15), 360: rem(18))))
          &:hover
            background: $green-hover
    .btn
      &__back
        background: #F6F6F6
        border: rem(1) solid #F6F6F6
        box-sizing: border-box
        border-radius: rem(4)
        display: flex
        flex-direction: row
        align-items: center
        text-decoration: none
        color: $red
        font-style: normal
        font-weight: 500
        font-size: rem(12)
        line-height: rem(20)
        transition: .5s
        font-family: $main-font
        cursor: pointer
        max-width: rem(320)
        +media((margin-right: (320: 0, 688: rem(10))))
        // +media((min-width: (320: 100%, 960: rem(320))))
        +media((margin-top: (320: rem(16), 960: 0)))
        +media((padding-left: (320: rem(17), 360: rem(30))))
        +media((height: (320: rem(64), 768: rem(68))))
        // +media((min-width: (320: 100%, 768: 50%, 992: rem(320))))
        +media((width: (320: 100%, 768: 50%, 960: rem(320))))
        svg
          +media((margin-right: (320: rem(20), 360: rem(28))))
          path, rect
            transition: .5s
        &:hover
          background: $red
          color: #fff
          border-color: $red
          svg
            path
              stroke: #fff
            rect
              fill: #fff
        &:hover
          background: $red
          color: #fff
          border-color: $red
          svg
            path
              stroke: #fff
        &-save
          +media((margin-top: (320: rem(32), 708: rem(44))))
          +media((margin-bottom: (320: rem(10), 708: rem(66))))
          &:nth-child(2)
            +media((margin-top: (320: rem(0), 708: rem(44))))
            +media((margin-bottom: (320: rem(48), 708: rem(66))))
    .info
      &__wrapper
        display: flex
        flex-direction: column
        justify-content: space-between
        +media((padding: (320: 0, 960: 0 0 0 rem(80))))
        &-box
          display: flex
          flex-direction: row
          align-items: flex-start
          +media((padding-top: (320: rem(40), 768: 0)))
          &--save
            +media((align-items: (320: flex-start, 768: center)))
            +media((padding-top: (320: rem(32), 768: rem(44))))
          &--form
            +media((display: (320: flex, 960: none)))
            +media((padding-top: (768: rem(23))))
          &--outer
            +media((display: (320: none, 960: flex)))
        &-text
          font-style: normal
          font-weight: 500
          font-size: rem(12)
          line-height: rem(24)
          text-align: left
          padding-left: rem(20)
    .copyLink
      +media((padding: (320: 0 rem(24), 992: 0)))
      &__wrapper
        //display: flex
        //flex-direction: row
        //align-items: center
        //justify-content: space-between
        display: grid
        overflow: hidden
        background: #FFFFFF
        border: rem(1) solid #ECECEC
        box-sizing: border-box
        border-radius: rem(4)
        width: 100%
        +media((grid-template-columns: (320: 7fr 5fr, 768: 2fr 17fr 5fr)))
        +media((height: (320: rem(48), 768: rem(68))))
        &-img
          width: rem(80)
          display: flex
          flex-direction: row
          justify-content: center
          align-items: center
          +media((display: (320: none, 768: flex)))
        &-input
          background: none
          box-shadow: none
          border: none
          font-style: normal
          font-weight: bold
          font-size: rem(14)
          line-height: rem(18)
          height: 100%
          text-overflow: ellipsis
          // pointer-events: none
          outline: none
          overflow: hidden
          +media((padding: (320: 0 rem(24), 768: 0 rem(24) 0 0)))
          &:disabled
            color: $black
        &-btn
          border: none
          outline: none
          box-shadow: none
          background: $red
          height: 100%
          transition: .5s
          font-style: normal
          font-weight: bold
          font-size: rem(14)
          line-height: rem(17)
          color: #FFFFFF
          width: rem(200)
          cursor: pointer
          +media((width: (320: 100%, 768: rem(200))))
          &:hover
            background: $red-hover
          span
            +media((display: (320: none, 768: inline-block)))
  .fade-enter-active, .fade-leave-active
    transition: opacity .5s

  .fade-enter, .fade-leave-to
    opacity: 0
</style>
